import type {
  CreditOutcomeProperty,
  IdentityOutcomeProperty,
  ResidentialOutcomeProperty,
} from '@/lib/apollo/model/outcome'
import { GraphQLOutcomeStatus } from '@/lib/apollo/model/outcome'
import { OutcomeStatus } from '@/types/Outcome'
import type {
  GraphQLOutcomeOverrideSection,
  OutcomeOverrideSection,
} from '@/types/OutcomeOverride'

export const shouldBeOverridden = (status?: OutcomeStatus): boolean => {
  if (!status) return false

  return [
    OutcomeStatus.fail,
    OutcomeStatus.accepted,
    OutcomeStatus.rejected,
    OutcomeStatus.conditionalPass,
  ].includes(status)
}

export const mapToGraphQLOverrides = (
  sections: OutcomeOverrideSection[],
): GraphQLOutcomeOverrideSection[] => {
  const updatedSections = sections.map(({ name, properties, status }) => {
    return {
      name,
      status: statusToGraphQLStatus(status),
      properties: properties.map(
        (
          property:
            | IdentityOutcomeProperty
            | CreditOutcomeProperty
            | ResidentialOutcomeProperty,
        ) => {
          return {
            name: property.name,
            status: statusToGraphQLStatus(property.status),
          }
        },
      ),
    }
  }) as GraphQLOutcomeOverrideSection[]
  return updatedSections
}

export const statusToGraphQLStatus = (status?: OutcomeStatus) => {
  switch (status) {
    case OutcomeStatus.awaitingResponse:
      return GraphQLOutcomeStatus.awaitingResponse
    case OutcomeStatus.awaitingReview:
      return GraphQLOutcomeStatus.awaitingReview
    case OutcomeStatus.reOpened:
      return GraphQLOutcomeStatus.reOpened
    case OutcomeStatus.accepted:
      return GraphQLOutcomeStatus.accepted
    case OutcomeStatus.rejected:
      return GraphQLOutcomeStatus.rejected
    case OutcomeStatus.conditionalPass:
      return GraphQLOutcomeStatus.conditionalPass
    case OutcomeStatus.conditionsMet:
      return GraphQLOutcomeStatus.conditionsMet
    case OutcomeStatus.fail:
      return GraphQLOutcomeStatus.fail
    case OutcomeStatus.pass:
      return GraphQLOutcomeStatus.pass
    default:
      return GraphQLOutcomeStatus.awaitingReview
  }
}

export const outcomeStatusToLabel = (status: OutcomeStatus) => {
  return status.replaceAll('_', ' ')
}

export const overallSectionOverride = [
  {
    label: 'Auto pass',
    status: OutcomeStatus.pass,
    disabled: true,
  },
  {
    label: outcomeStatusToLabel(OutcomeStatus.rejected),
    status: OutcomeStatus.rejected,
  },
  {
    label: outcomeStatusToLabel(OutcomeStatus.conditionalPass),
    status: OutcomeStatus.conditionalPass,
  },
  {
    label: outcomeStatusToLabel(OutcomeStatus.accepted),
    status: OutcomeStatus.accepted,
  },
  {
    label: outcomeStatusToLabel(OutcomeStatus.reOpened),
    status: OutcomeStatus.reOpened,
    disabled: true,
  },
  {
    label: outcomeStatusToLabel(OutcomeStatus.fail),
    status: OutcomeStatus.fail,
    disabled: true,
  },
  {
    label: outcomeStatusToLabel(OutcomeStatus.conditionsMet),
    status: OutcomeStatus.conditionsMet,
    disabled: true,
  },
  {
    label: outcomeStatusToLabel(OutcomeStatus.awaitingReview),
    status: OutcomeStatus.awaitingReview,
    disabled: true,
  },
  {
    label: outcomeStatusToLabel(OutcomeStatus.awaitingResponse),
    status: OutcomeStatus.awaitingResponse,
    disabled: true,
  },
]
